import React from "react";
import {CognitoUser} from "amazon-cognito-identity-js";
import {Auth, Hub} from "aws-amplify";
import {debug_log} from "../utils/debug";

function getUser(): Promise<CognitoUser | null> {
    return Auth.currentAuthenticatedUser()
        .then(userData => userData, () => null);
}

export const useUserInfo = () => {
    const [user, setUser] = React.useState<CognitoUser | null>(null);
    const [userEmail, setUserEmail] = React.useState<string | null>(null);

    React.useEffect(() => {
        Hub.listen("auth", (capsule) => {

            switch (capsule.payload.event) {
                case "signIn":
                case 'cognitoHostedUI':
                    getUser().then(userData => setUser(userData));
                    break;

                case "signOut":
                    setUser(null);
                    break;
                default:
                    debug_log(capsule.payload.event, capsule);
            }
        });
        getUser().then(userData => {
            setUser(userData);

            if (userData) {
                userData.getUserAttributes((e, attrs) => {
                    const user_attributes = {} as any;
                    attrs?.forEach((a) => {
                        user_attributes[a.getName()] = a.getValue()
                    });
                    if (user_attributes.email) {
                        setUserEmail(user_attributes.email);
                    }
                });
            }

        });
    }, []);

    return {userName: user?.getUsername(), userEmail: userEmail, isLogin: user && userEmail};
}
